import { render, staticRenderFns } from "./MadeUpForm.vue?vue&type=template&id=6ab29521&scoped=true"
import script from "./MadeUpForm.vue?vue&type=script&lang=js"
export * from "./MadeUpForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab29521",
  null
  
)

export default component.exports